import { styled } from '@mui/joy';

import { externalQuoteTheme } from 'external-quote/styles';

export const HeaderContainer = styled('div')({
  backgroundColor: '#FAFAFA',
  borderBottom: '1px solid #E0E0E0',
  display: 'flex',
  flexDirection: 'column',
});

export const HeaderTop = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '6px 16px',
  borderBottom: '1px solid #E0E0E0',
});

export const HeaderBottom = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '10px 16px',
});

export const OrderLabel = styled('span')({
  fontSize: '17px',
  color: '#666666',
});

export const ManageText = styled('span')({
  fontSize: '17px',
  color: '#666666',
});

export const OrderInfo = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const OrderNumber = styled('span')({
  fontSize: '17px',
  fontWeight: 600,
  color: '#333333',
});

export const CustomerName = styled('span')({
  fontSize: '17px',
  color: '#333333',
});

export const StatusBadge = styled('span')({
  backgroundColor: '#E3F2FD',
  color: '#1976D2',
  padding: '3px 10px',
  borderRadius: '4px',
  fontSize: '14px',
  fontWeight: 500,
});

export const MetaInfo = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '20px',
});

export const MetaItem = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
});

export const MetaLabel = styled('span')({
  fontSize: '14px',
  color: externalQuoteTheme.colors.textSecondary,
});

export const MetaValue = styled('span')({
  fontSize: '17px',
  color: externalQuoteTheme.colors.textPrimary,
  fontWeight: 500,
});
